import {
  Button,
  H3Heavy,
  MediaQuery,
  ProfileAvatar,
} from '@pelando/components';
import styled from 'styled-components';

export const ModalContainer = styled.div`
  text-align: center;
`;

export const ModalAvatar = styled(ProfileAvatar)`
  margin-bottom: 16px;
`;

export const ModalTitle = styled.p`
  ${H3Heavy}
  margin-bottom: 24px;
`;

export const ModalButton = styled(Button)`
  height: 48px;
  display: block;
  width: 100%;

  &:first-of-type {
    margin-bottom: 8px;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    &:first-of-type {
      margin-bottom: 16px;
    }
  }
`;
